import { TypographyBase } from "./TypographyBase";
import {
  TypographyCode,
  TypographyEm,
  TypographyH1,
  TypographyH2,
  TypographyH3,
  TypographyH4,
  TypographyH5,
  TypographyH6,
  TypographyLabel,
  TypographyOption,
  TypographyP,
  TypographyQuote,
  TypographySmall,
  TypographySpan,
  TypographyStrong,
} from "./Variations";

export * from "./TypographyBase";
export * from "./Variations";

const Typography = Object.assign(TypographyBase, {
  Span: TypographySpan,
  Label: TypographyLabel,
  H1: TypographyH1,
  H2: TypographyH2,
  H3: TypographyH3,
  H4: TypographyH4,
  H5: TypographyH5,
  H6: TypographyH6,
  P: TypographyP,
  Small: TypographySmall,
  Strong: TypographyStrong,
  Em: TypographyEm,
  Code: TypographyCode,
  Quote: TypographyQuote,
  Option: TypographyOption,
});

Typography.displayName = "Typography";
Typography.Span.displayName = "Typography.Span";
Typography.Label.displayName = "Typography.Label";
Typography.H1.displayName = "Typography.H1";
Typography.H2.displayName = "Typography.H2";
Typography.H3.displayName = "Typography.H3";
Typography.H4.displayName = "Typography.H4";
Typography.H5.displayName = "Typography.H5";
Typography.H6.displayName = "Typography.H6";
Typography.P.displayName = "Typography.P";
Typography.Small.displayName = "Typography.Small";
Typography.Strong.displayName = "Typography.Strong";
Typography.Em.displayName = "Typography.Em";
Typography.Code.displayName = "Typography.Code";
Typography.Quote.displayName = "Typography.Quote";
Typography.Option.displayName = "Typography.Option";

export { Typography };
